import { getUserCustomAttributeStringValue } from 'shared-helpers/customAttributes';
import { attributesExpressionOptions } from 'lib/customAttributes';

import type {
  AttributeCondition,
  Locales,
  UserCustomAttribute
} from 'shared-types';
import type { ReduxRootState } from 'types';

interface Params {
  conditions: AttributeCondition[];
  language: Locales;
  messages: ReduxRootState['messages'];
  userCustomAttributesByKey: {
    [key: string]: UserCustomAttribute;
  };
}

const getAttributeConditionsString = ({
  conditions,
  language,
  messages,
  userCustomAttributesByKey
}: Params) => {
  const expressions = attributesExpressionOptions({ messages, type: 'all' });

  let conditionsString = `${messages.userAttributesConditions}: `;
  if (conditions?.length) {
    conditions.forEach((condition, index) => {
      const attribute = userCustomAttributesByKey[condition.key];
      conditionsString += index === 0 ? '' : ` ${messages.commonAnd} `;
      conditionsString += `${
        attribute
          ? attribute.titleTranslations?.[language] || attribute.title
          : condition.key
      } `;
      conditionsString += `${
        expressions.find(
          (expression) => expression.value === condition.expression
        )?.label
      } `;
      conditionsString += attribute
        ? getUserCustomAttributeStringValue({
            attribute,
            language,
            messages,
            value: condition.value
          })
        : condition.value;
    });
  } else {
    conditionsString += '-';
  }
  return conditionsString;
};

export default getAttributeConditionsString;
